"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _components = require("@/ui/components");
var _vuex = require("vuex");
var _moment = _interopRequireDefault(require("moment"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var _default = exports.default = {
  name: 'ModalScheduling',
  components: {
    AppInput: _components.AppInput,
    AppSelect: _components.AppSelect
  },
  props: {
    serviceItem: {
      type: [Number, String],
      default: null
    }
  },
  data: function data() {
    return {
      activeTab: null,
      scheduling: {},
      load: false,
      dueDate: new Date(),
      filteredTags: [],
      isSelectOnly: false,
      tags: [],
      isOpen: null,
      customFieldsActive: []
    };
  },
  mounted: function () {
    var _mounted = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            this.getData();
          case 1:
            return _context.a(2);
        }
      }, _callee, this);
    }));
    function mounted() {
      return _mounted.apply(this, arguments);
    }
    return mounted;
  }(),
  computed: _objectSpread(_objectSpread({}, (0, _vuex.mapGetters)({
    storeServicetypes: 'storeServicetypes',
    isLoading: 'isLoading'
  })), {}, {
    isChangeDueDate: function isChangeDueDate() {
      var oldDate = _moment.default.utc(this.scheduling.dueDate).format('YYYY/MM/DD');
      var newDate = _moment.default.utc(this.dueDate).format('YYYY/MM/DD');
      return oldDate !== newDate;
    },
    schedulePlots: function schedulePlots() {
      var plots = this.scheduling.plots || [];
      return plots;
    },
    scheduleSubPlots: function scheduleSubPlots() {
      var subPlots = this.scheduling.subPlots || [];
      return subPlots;
    },
    scheduleRows: function scheduleRows() {
      var rows = this.scheduling.rows || [];
      return rows;
    },
    scheduleFamilies: function scheduleFamilies() {
      var families = this.scheduling.families || [];
      return families;
    },
    steps: function steps() {
      if (this.scheduling.stepsCompleted) {
        return this.scheduling.stepsCompleted || [];
      }
      return [];
    }
  }),
  methods: _objectSpread(_objectSpread({}, (0, _vuex.mapActions)(['getServiceTypes', 'fetchServiceDetailItem', 'fetchServiceCustomFieldValues', 'updateServiceFinished'])), {}, {
    getData: function () {
      var _getData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var data, date;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return this.fetchServiceDetailItem(this.serviceItem);
            case 1:
              data = _context2.v;
              if (data) {
                this.scheduling = data;
                date = _moment.default.utc(data.dueDate);
                this.dueDate = new Date(date.format('YYYY/MM/DD'));
              }
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function getData() {
        return _getData.apply(this, arguments);
      }
      return getData;
    }(),
    getFilteredTags: function getFilteredTags(text) {
      console.log('text: ', text);
    },
    openTab: function () {
      var _openTab = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(index, item) {
        var _item$serviceStepType;
        var fields, ids, customValues;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              this.customFieldsActive = [];
              this.isOpen = index;
              fields = (item === null || item === void 0 ? void 0 : (_item$serviceStepType = item.serviceStepType) === null || _item$serviceStepType === void 0 ? void 0 : _item$serviceStepType.customFields) || [];
              ids = fields.map(function (itemCF) {
                return {
                  customFieldId: itemCF.id,
                  servicestepsId: item.id
                };
              });
              customValues = [];
              if (!ids.length) {
                _context3.n = 2;
                break;
              }
              _context3.n = 1;
              return this.fetchServiceCustomFieldValues(ids);
            case 1:
              customValues = _context3.v;
            case 2:
              this.customFieldsActive = fields.map(function (cf) {
                var valueItem = customValues.find(function (v) {
                  return Number(v.customFieldId) === Number(cf.id);
                });
                var displayValue = (valueItem === null || valueItem === void 0 ? void 0 : valueItem.customFieldValue) || null;

                // AQUI É O QUE IMPORTA AGORA:
                if (cf.type === 'date' && displayValue) {
                  // Converte "2025-08-25T19:12:00.000Z" → "25/08/2025"
                  var date = new Date(displayValue);
                  var day = String(date.getUTCDate()).padStart(2, '0');
                  var month = String(date.getUTCMonth() + 1).padStart(2, '0');
                  var year = date.getUTCFullYear();
                  displayValue = "".concat(day, "/").concat(month, "/").concat(year);
                }
                return _objectSpread(_objectSpread({}, cf), {}, {
                  idUpdate: (valueItem === null || valueItem === void 0 ? void 0 : valueItem.id) || null,
                  value: displayValue,
                  servicestepsId: item.id
                });
              });
            case 3:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function openTab(_x, _x2) {
        return _openTab.apply(this, arguments);
      }
      return openTab;
    }(),
    updateItens: function () {
      var _updateItens = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var customFieldsToSend, payload, data;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              customFieldsToSend = this.customFieldsActive.map(function (cf) {
                var valueToSend = cf.value;
                if (cf.type === 'date' && valueToSend) {
                  var _valueToSend$split = valueToSend.split('/'),
                    _valueToSend$split2 = _slicedToArray(_valueToSend$split, 3),
                    day = _valueToSend$split2[0],
                    month = _valueToSend$split2[1],
                    year = _valueToSend$split2[2];
                  // valueToSend = `${year}-${month}-${day}` // formato YYYY-MM-DD
                  // backend exigi ISO completo:
                  valueToSend = "".concat(year, "-").concat(month, "-").concat(day, "T00:00:00.000Z");
                }
                return {
                  customFieldId: cf.id,
                  servicestepsId: cf.servicestepsId,
                  idUpdate: cf.idUpdate || undefined,
                  value: valueToSend
                };
              }).filter(function (item) {
                return item.value !== null && item.value !== '';
              });
              payload = {
                item: this.serviceItem,
                customFields: customFieldsToSend
              };
              _context4.n = 1;
              return this.updateServiceFinished({
                id: this.serviceItem,
                payload: payload
              });
            case 1:
              data = _context4.v;
              if (data) {
                this.$buefy.toast.open({
                  message: 'Dados alterados com sucesso!',
                  type: 'is-success'
                });
                this.$emit('close');
              }
            case 2:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function updateItens() {
        return _updateItens.apply(this, arguments);
      }
      return updateItens;
    }()
  })
};